(() => {
  if (customElements.get('ofx-showroom-banner')) return;
  customElements.define('ofx-showroom-banner', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      this.hero = this.querySelector('.ofx-showroom__hero');
      this.counter = this.querySelector('[data-current]');
      this.index = 0;
      this.request = 0;
      this.ready = false;
      this.touch = null;
      this.editorSelected = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(2000, Number(this.dataset.interval) || 2000);
      const on = (target, type, fn, options = {}) => target?.addEventListener(type, fn, { ...options, signal: this.events.signal });
      on(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1));
      on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1));
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.show(index)));
      on(this.hero, 'touchstart', event => {
        this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : {};
        this.schedule();
      }, { passive: true });
      on(this.hero, 'touchend', event => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
        else this.schedule();
      }, { passive: true });
      on(this.hero, 'touchcancel', () => { this.touch = null; this.schedule(); }, { passive: true });
      on(this, 'focusin', () => this.schedule());
      on(this, 'focusout', () => queueMicrotask(() => { if (this.isConnected) this.schedule(); }));
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => this.schedule());
      on(this, 'shopify:block:select', event => {
        this.editorSelected = true;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index);
      });
      on(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); });
      if (!this.slides.length) return;
      // Keep only the first image on the initial paint's network path.
      this.load(0).then(() => requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.ready = true;
        if (this.slides.length > 1) this.load(1);
        this.schedule();
      })));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.request++;
    }
    async load(index) {
      const img = this.slides[index]?.querySelector('img');
      if (!img) return false;
      if (img.dataset.src) {
        img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        delete img.dataset.src;
        delete img.dataset.srcset;
      }
      try { await img.decode(); } catch (_) { /* Retain the last good slide if an image fails. */ }
      return img.naturalWidth > 0;
    }
    async show(index) {
      clearTimeout(this.timer);
      const next = (index + this.slides.length) % this.slides.length;
      const request = ++this.request;
      const loaded = await this.load(next);
      if (!this.isConnected || request !== this.request) return;
      if (loaded) {
        this.index = next;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === next);
          slide.setAttribute('aria-hidden', String(i !== next));
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === next);
          dot.setAttribute('aria-pressed', String(i === next));
        });
        this.counter.textContent = next + 1;
        this.load((next + 1) % this.slides.length);
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.ready || this.slides.length < 2 || this.motion.matches || document.hidden || this.touch || this.editorSelected || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
  });
})();
